$ = jQuery;